
import React, {useState} from 'react';
import style from './style.module.scss'; // won't generate a '.d.ts' file until component is included in the app
import {IProps, IHandlers} from './types';
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Paper, Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core';
import {Close} from "@material-ui/icons";
import {BookingType, IBookingTag} from "shared-types/index";
import BookingTagEditor from './bookingTagEditor';

const NS = 'MegaBookingBot';

export default function MegaBookingBot({
    customerList,
    handleClose, addBookings, cancelAllBookingsForToday, handleCustomerSearch, handleCustomerSelect, handleBookingType
}: IProps & IHandlers) {

  const defaultQty = 2;
  const defaultDuration = 60;
  const [qty, setQty] = useState<number>(defaultQty);
  const [duration, setDuration] = useState<number>(defaultDuration);
  const [customerSearch, setCustomerSearch] = useState<string>("");
  const [customerSelected, setCustomerSelected] = useState<boolean>(false);
  const [bookingsAdded, setBookingsAdded] = useState<boolean>(false);
  const [bookingType, setBookingType] = useState<BookingType>(BookingType.Booking);
  const [tags, setTags] = useState<IBookingTag[]>([]);

  const handleTags = (tags: IBookingTag[]) => {
    setTags(tags);
  }

  return (
    <Paper elevation={1} className={style.root}>

      <IconButton
        className={style.closeBtn}
        aria-label="close" onClick={handleClose}
      ><Close /></IconButton>

      <Typography className={style.title} variant="h2">
        <img className={style.icon} src="/images/mega-booking-bot-icon-large.png" />
        <span>Mega Booking Bot</span>
      </Typography>

      <Typography className={style.desc} variant="body1">
        Tool for rapidly filling up a schedule with bookings. Useful for testing performance.
      </Typography>
      <Typography className={style.desc} variant="body1">
        You may want to configure your venue to not send out emails for each booking to avoid clogging your inbox.
      </Typography>

      <div className={style.inputs}>
        <TextField
          type="number"
          defaultValue={defaultQty}
          label="Booking count"
          onChange={(evt) => setQty(parseInt(evt.currentTarget.value))}
        />

        <TextField
          type="number"
          defaultValue={defaultDuration}
          label="Booking duration"
          onChange={(evt) => setDuration(parseInt(evt.currentTarget.value))}
        />
      </div>

      <div className={style.customerSearch}>
        <TextField
          type="text"
          label="Find Customer"
          onChange={(evt) => setCustomerSearch(evt.currentTarget.value)}
        />

        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleCustomerSearch(customerSearch);
          }} >
          Search
        </Button>
      </div>

      {customerList.length > 0 &&
        <FormControl component="fieldset" className={style.customerList}>
          <RadioGroup onChange={evt => {
            setCustomerSelected(true);
            handleCustomerSelect(evt.currentTarget.value);
          }}>
            {customerList.map(customer => (
              <FormControlLabel
                key={customer._id}
                className={style.customerListItem}
                value={customer._id}
                control={<Radio />}
                label={customer.fullName}
              />
            ))}
          </RadioGroup>
        </FormControl>
      }

      <BookingTagEditor handleTags={handleTags} />

      <div className={style.btns} >
        {customerSelected &&
          <Button
            disabled={bookingsAdded}
            color="primary"
            variant="contained"
            onClick={() => {
              setBookingsAdded(true);
              addBookings(qty, duration, tags);
            }}>
            Add Bookings
          </Button>
        }

        <RadioGroup value={bookingType} onChange={(evt, value) => {
          setBookingType(value as BookingType);
          handleBookingType(value as BookingType);
        }}>
          <FormControlLabel control={<Radio color="primary" />} label="Booking" value={BookingType.Booking} />
          <FormControlLabel control={<Radio color="primary" />} label="Wait List" value={BookingType.WaitList} />
          <FormControlLabel control={<Radio color="primary" />} label="Standby List" value={BookingType.StandbyList} />
        </RadioGroup>

        <Button
          color="primary"
          variant="outlined"
          onClick={() => {
            cancelAllBookingsForToday();
          }} >
          Cancel all bookings for today
        </Button>
      </div>

    </Paper>
  )
}

